import { AdjustmentLabels } from '../summaryV2/PairedCostAdjustmentSummary/types.ts';

export const ADJUSTMENT_LABELS: AdjustmentLabels = {
  dateOfSale: 'Date of Sale',
  concessions: 'Financial Concessions',
  termsOfSale: 'Terms of Sale',
  site: {
    size: 'Site Size',
    location: 'Location',
    view: 'View',
  },
  functionalUtility: 'Functional Utility',
  externalObsolescence: 'External Obs',
  quality: 'Quality',
  condition: 'Condition',
  mainDwelling: {
    gla: 'GLA',
    propertyType: 'Property Type',
    units: 'Units',
    foundation: 'Foundation',
  },
  bathAboveGrade: 'Bath Count',
  bathBelowGrade: 'Bath Count (Below Grade)',
  garageCarport: 'Garage / Carport',
  basement: 'Basement',
  manual: 'Manual Cost',
  adu: 'ADU',
  attic: 'Attic',
  barn: 'Barn',
  bonusRoom: 'Bonus Room',
  fireplace: 'Fireplace',
  porchPatioDeck: 'Porch/Patio/Deck',
  pool: 'Pool',
  shed: 'Shed',
  workshop: 'Workshop',
  manufactured: 'Mfd. Dwelling',
  belowGradeANSI: 'Below Grade (per ANSI)',
  locationView: 'Location & View',
};
